import React from 'react';
import styled from '@emotion/styled';
import { FaSearch } from 'react-icons/fa';

const SearchContainer = styled.div`
  position: relative;
  flex: 1;
`;

const StyledInput = styled.input`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: ${props => props.theme.colors.text};
  padding: 8px 16px;
  padding-left: 40px;
  border-radius: 4px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.primary};
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

const SearchIcon = styled(FaSearch)`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
`;

const SearchInput = ({ value, onChange, placeholder }) => {
  return (
    <SearchContainer>
      <SearchIcon />
      <StyledInput
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </SearchContainer>
  );
};

export default SearchInput; 